import { Row, CardBody } from "reactstrap";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Href } from "../../../Constant";
import { HOVER_IMAGE_LIST } from "../../../Data/Gallery";
import { Link } from "react-router-dom";
import { dynamicImage } from "../../../Service/DynamicImage";

export const ImageHoverEffectsCardBody = (props: { data: number }) => {
  return (
    <CardBody>
      <Row className="my-gallery gallery mb-auto">
        <Gallery>
          {HOVER_IMAGE_LIST &&
            HOVER_IMAGE_LIST.map((item, index) => (
              <figure className={`m-0 col-md-3 col-6 img-hover hover-${props.data}`} key={index}>
                <Item original={dynamicImage(`${item}`)} width="1024" height="768">
                  {({ ref, open }) => (
                    <Link to={Href} onClick={open}>
                      <div className="overflow-hidden">
                        <img className="img-thumbnail" ref={ref} src={dynamicImage(`${item}`)} alt="" />
                      </div>
                    </Link>
                  )}
                </Item>
              </figure>
            ))}
        </Gallery>
      </Row>
    </CardBody>
  );
};
